import React, { ButtonHTMLAttributes, ReactNode } from "react";
import { useTranslations } from "@adsk/acc-issues-translations";
import Button from "@adsk/alloy-react-button";
import { ClockArrowCircleIcon } from "@adsk/alloy-react-icon";
import { ConditionalTooltip } from "@adsk/acc-issues-common/components/primitive/ConditionalTooltip";
import { CSSObject } from "styled-components";

export const RestoreDeletedIssueButton = ({
  style,
  disabledReason,
  tooltipContainer,
  shouldBeSkinny,
  disabled,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  disabled: boolean;
  disabledReason?: ReactNode;
  tooltipContainer?: any;
  shouldBeSkinny?: boolean;
}) => {
  const { T } = useTranslations();
  const buttonText = T.translate("deletedIssues.restoreIssueButton");
  const hasDisabledTooltip = Boolean(disabled && disabledReason);

  return (
    <ConditionalTooltip
      style={{ maxWidth: 300 }}
      condition={hasDisabledTooltip}
      container={tooltipContainer}
      content={disabledReason!}
    >
      <Button
        data-testid="restore-button"
        style={style as CSSObject}
        variant={Button.VARIANTS.TERTIARY}
        renderIcon={p => <ClockArrowCircleIcon {...p} />}
        disabled={disabled}
        {...props}
      >
        {!shouldBeSkinny && buttonText}
      </Button>
    </ConditionalTooltip>
  );
};
